<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/mobileHome')" class="breadcrumbs-txt">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div v-if="route.query.type === '专业营养'" class="breadcrumbs-txt1">专业营养 Professional Nutrition</div>
      <div v-if="route.query.type === '基础营养'" class="breadcrumbs-txt1">基础营养 Complete Multivitamin</div>
      <div v-if="route.query.type === '果味营养'" class="breadcrumbs-txt1">果味营养 Natural Fruit Bites Multivitamin</div>
    </div>
    <div class="main-content">
      <div class="flex column" style="padding: 0 0.32rem; box-sizing: border-box">
        <img class="banner" :src="require(`@/assets/mobile/product/${productList[typeIndex].imgUrl}Banner.png`)"
          alt="" />
        <div class="product-name">{{ productList[typeIndex].name }}</div>
        <div class="product-english-name">{{ productList[typeIndex].englishName }}</div>
        <div class="nutrition-box">
          <img v-for="(item, index) in productList[typeIndex].num" key="index" class="nutrition"
            :src="require(`@/assets/mobile/product/${productList[typeIndex].imgUrl}${index + 1}.png`)" alt="" />
        </div>
      </div>
      <MobileFooter />
    </div>
  </div>
</template>

<script setup>
import MobileFooter from "@/components/mobileFooter.vue";
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
const route = useRoute();
const router = useRouter();
const productList = ref([
  {
    name: "专业营养",
    imgUrl: "specialty",
    englishName: "PROFESSIONAL NUTRITION",
    num: 10,
  },
  {
    name: "基础营养",
    imgUrl: "basics",
    englishName: "COMPLETE MULTIVITAMIN",
    num: 6,
  },
  {
    name: "果味营养",
    imgUrl: "fruity",
    englishName: "NATURAL FRUIT BITES MULTIVITAMIN",
    num: 3,
  },
]);
const typeIndex = ref(0);
// 初始化加载
fetchData(route.query);
// 监听路由变化
watch(
  () => route.query,
  (newQuery) => {
    fetchData(newQuery);
  },
  { deep: true }
);
// 获取数据的函数
async function fetchData(params) {
  // 根据参数获取数据
  typeIndex.value = productList.value.findIndex((item) => item.name === route.query.type);
}
</script>

<style src="./mobileProduct.css" scoped></style>
